import React, { createContext, useEffect, useReducer, useState } from "react";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {

  ROLES_DASHBOARD,
  ROLES_USERS,
  ROLES_POSTS,
  ROLES_STORIES,
  ROLES_REELS,
  ROLES_QUERIES,
  ROLES_CONTENT,
  // ROLES_MUSICS,

} from "../constants/actionTypes";
import henceforthApi from "../utils/henceforthApi";
import logoutSuccess from "./actions/auth/logoutSuccess";
import authInitialState from "./initialStates/authInitialState";
import authInitialStaticData from "./initialStates/authInitialStaticData";
import auth from "./reducers/auth";
import pagination from "./reducers/pagination";
import static_data from "./reducers/static_data";

export const GlobalContext = createContext({});

function GlobalProvider({ children }) {
  let navigate = useNavigate();
  // const match=useMatch()
  const [loading, setLoading] = useState(false);
  const [currentUsd, setCurrenctUsd] = useState(0);
  const location = useLocation()
  const newParam = new URLSearchParams(location.search)
  const [authState, authDispatch] = useReducer(auth, authInitialState, () => {
    const localAuthState = localStorage.getItem("authState");
    return localAuthState ? JSON.parse(localAuthState) : authInitialState;
  });

  const [staticDataState, staticDataDispatch] = useReducer(
    static_data,
    authInitialStaticData,
    () => {
      const localStaticDataState = localStorage.getItem("staticDataState");
      return localStaticDataState
        ? JSON.parse(localStaticDataState)
        : authInitialStaticData;
    }
  );

  const scrollToTop = () => {
    if (window) {
      window.scrollTo(0, 0);
    }
  };
  // console.log(match,"params");
  const logOutNow = () => {
    logoutSuccess({})(authDispatch);
    logoutSuccess(authInitialStaticData)(staticDataDispatch);
    navigate("/", { replace: true });
  };
  const staffMembers = [
    // ROLES_STAFF_MEMBERS,
    ROLES_DASHBOARD,
    ROLES_USERS,
    ROLES_POSTS,
    ROLES_STORIES,
    ROLES_REELS,
    ROLES_QUERIES,
    ROLES_CONTENT,
    // ROLES_MUSICS,
  ];

  const handleError = (error) => {
    if (error?.response?.body?.error === "UNAUTHORIZED") {
      logOutNow()
    } else {
      toast.error((typeof error?.response?.body?.error_description === "string") ? error?.response?.body?.error_description : JSON.stringify(error?.response?.body?.error_description))
    }
  }
  // const 

  const handleFilter = (name, value) => {
    if (value) {
      newParam.set(name, value)
    }
    else {
      newParam.delete(name)
    }
    if (location.pathname.startsWith("/users")) {
      navigate({ pathname: "/users/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/posts")) {
      navigate({ pathname: "/posts/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reels")) {
      navigate({ pathname: "/reels/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/stories")) {
      navigate({ pathname: "/stories/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reported-posts")) {
      navigate({ pathname: "/reported-posts/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reported-stories")) {
      navigate({ pathname: "/reported-stories/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reported-reels")) {
      navigate({ pathname: "/reported-reels/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/transaction")) {
      navigate({ pathname: "/transaction/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/suscriber")) {
      navigate({ pathname: "/suscriber/1", search: newParam.toString() })
    }
    if (location.pathname.startsWith("/user-Messages")) {
      navigate({ pathname: "/user-Messages/1", search: newParam.toString() })
    }
    // if(location.pathname.startsWith("/reported-reels")){
    //   navigate({pathname:"/reported-reels/1",search:newParam.toString()})
    // }
    // if(location.pathname.startsWith("/reported-reels")){
    //   navigate({pathname:"/reported-reels/1",search:newParam.toString()})
    // }
  }
  const handlePagination = (page) => {
    if (location.pathname.startsWith("/users")) {
      navigate({ pathname: `/users/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/posts")) {
      navigate({ pathname: `/posts/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reels")) {
      navigate({ pathname: `/reels/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/stories")) {
      navigate({ pathname: `/stories/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reported-posts")) {
      navigate({ pathname: `/reported-posts/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reported-stories")) {
      navigate({ pathname: `/reported-stories/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/reported-reels")) {
      navigate({ pathname: `/reported-reels/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/transaction")) {
      navigate({ pathname: `/transaction/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/suscriber")) {
      navigate({ pathname: `/suscriber/${page}`, search: newParam.toString() })
    }
    if (location.pathname.startsWith("/user-Messages")) {
      navigate({ pathname: `/user-Messages/${page}`, search: newParam.toString() })
    }
  }
  useEffect(() => {
    localStorage.setItem("authState", JSON.stringify(authState));
  }, [authState]);

  useEffect(() => {
    localStorage.setItem("staticDataState", JSON.stringify(staticDataState));
  }, [staticDataState]);

  // useEffect(() => {
  //     localStorage.setItem("pagination", JSON.stringify(paginationState))
  // }, [paginationState]);

  const initialiseFirstTime = async () => {
    let ethusd = await henceforthApi.Common.ethusd();
    setCurrenctUsd(ethusd.body.USD);
  };
  useEffect(() => {
    initialiseFirstTime();
  }, []);

  //   console.log("QueriesUsersData", getQueries);

  return (
    <GlobalContext.Provider
      value={{
        currentUsd,
        authState,
        staffMembers,
        authDispatch,
        scrollToTop,
        handleFilter,
        loading,
        handleError,
        handlePagination,
        setLoading,
        staticDataState,
        staticDataDispatch,
        logOutNow,
        Toast: {
          success: toast.success,
          error: toast.error,
          info: toast.info,
          warn: toast.warn,
        },
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}

export default GlobalProvider;
